import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/Invoice.css";
import { getInvoiceData } from '../Api/ViewPostedInvoice';
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
const { ToWords } = require('to-words');
const toWords = new ToWords({
  localeCode: 'en-IN',    // Indian format
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false
  }
});
const VendorInvoiceBody=({invoiceData})=>{
 const componentRef = useRef();
  const toWords = new ToWords();
  const location = useLocation();
  const handlePrint = useReactToPrint({
    contentRef: componentRef, // ✅ new API for v3+
    documentTitle: "Invoice",
  });

  const invoiceId = location.pathname.split("/")[2];

  console.log(invoiceId, 'invoiceId')
  // const [invoiceData, setInvoiceData] = useState({});
  const [count, setCount] = useState("");
  // useEffect(() => {
  //   const fetchInvoiceData = async () => {
  //     const res = await getInvoiceData(invoiceId);
  //     console.log(res, 'res dngjf jhjkdt hjkt');
  //     setInvoiceData(res)
  //     setCount(res?.items?.length)
  //   }
  //   fetchInvoiceData()
  // }, [])
  const totalGSTWords = toWords.convert(
  (Number(invoiceData?.invoiceSummary?.totalCGST || 0) +
   Number(invoiceData?.invoiceSummary?.totalSGST || 0) +
   Number(invoiceData?.invoiceSummary?.totalIGST || 0)),
  { currency: true }
).toUpperCase();
  console.log(invoiceData, 'invoiceData')

    return(
        <div>
         {/* <!-- Products Table --> */}
          <table className="products-table">
            <thead>
              <tr>
                <th>SR. NO.</th>
                <th>PRODUCT DESCRIPTION</th>
                <th>HSN/SAC CODE</th>
                {/* <th>Batch Number</th> */}
                <th>MRP</th>
                {/* <th>Batch Qty.</th>
                <th>MRP</th> */}
                {/* <th>Expiry Date</th> */}
                <th>ORIGINAL QUANTITY</th>
                <th>RECIEVED QUANTITY</th>
                <th>BALANCE QUANTITY</th>
                <th>UOM</th>
                {/* <th>BILLING RATE</th>
                <th>BASIC VALUE</th>
                <th>DISC %</th>
                <th>DISCOUNT VALUE</th>
                <th>TAXABLE VALUE</th>
                <th colspan="2">IGST</th>
                <th colspan="2">CGST</th>
                <th colspan="2">SGST</th>
                <th>Gross Value</th> */}
              </tr>
              <tr>
                {/* <th></th>
                <th></th>
                <th></th>
                <th></th>
                {/* <th></th>
                <th></th> */}
                {/* <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th>RATE%</th>
                <th>AMOUNT</th>
                <th>RATE%</th>
                <th>AMOUNT</th>
                <th>RATE%</th>
                <th>AMOUNT</th> */}
                {/* <th></th>  */}
                

              </tr>
            </thead>
            <tbody>
              {invoiceData?.inventory?.length > 0 && invoiceData?.inventory.map((data, index) => {
                console.log(data,"bfajsbj")
               return data?.inventoryItems.map((data,index)=>{
                console.log(data?.items);
                       return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data?.items?.description}</td>
                    <td>{data?.itemsMain?.hsnId}</td>
                    {/* <td>{data?.invoiceItem?.batchId}</td> */}
                    <td>₹{data?.items?.price}</td>
                    {/* <td>NULL</td>
                    <td>NULL</td> */}
                    {/* <td>{data?.expiryDate?.split("T")[0].split("-").reverse().join("-")}</td> */}
                    <td>{data?.items?.originalQuantity}</td>
                    <td>{data?.items?.quantityReceived}</td>
                    <td>{data?.items?.balanceQuantity}</td>
                    <td>{data?.items?.unit}</td>
                    {/* <td>₹{data?.items?.price}</td>
                    <td>
                      {`₹${(parseFloat(data?.invoiceItem?.price || 0) *
                        parseFloat(data?.invoiceItem?.quantity || 0))}`}
                    </td>
                    <td>{data?.invoiceItem?.discPercent.toFixed(2)}</td>
                    <td>₹{data?.invoiceItem?.discountValue.toFixed(2)}</td>
                    <td>₹{data?.invoiceItem?.taxableValue.toFixed(2)}</td> */}
                    {/* <td>{`₹${(parseFloat(data?.invoiceItem?.price || 0) *
                     parseFloat(data?.invoiceItem?.quantity || 0)).toFixed(2) - parseFloat(data?.invoiceItem?.discountValue)}`}</td> */}
{/* 
                    <td>{data?.invoiceItem?.igst}</td>
                    <td>₹{parseFloat(data?.invoiceItem?.igstAmount.toFixed(2))}</td>
                    <td>{data?.invoiceItem?.cgst}</td>
                    <td>{data?.invoiceItem?.cgstAmount.toFixed(2)}</td>
                    <td>{data?.invoiceItem?.sgst}</td>
                    <td>₹{parseFloat(data?.invoiceItem?.sgstAmount.toFixed(2))}</td>

                    <td>₹{data?.invoiceItem?.grossValue.toFixed(2)}</td> */}

                  </tr>
                )
                })
             
              })}
            </tbody>
          </table>

          {/* <!-- HSN Summary --> */}
          {/* <div className="hsn-summary">
            <table className="hsn-table">
              <thead>
                <tr>
                  <th>HSN WISE SUMMARY</th>
                  <th>HSN CODE</th>
                  <th>TAXABLE VALUE</th>
                  <th>IGST RATE %</th>
                  <th>IGST AMOUNT</th>
                  <th>CGST RATE %</th>
                  <th>CGST AMOUNT</th>
                  <th>SGST/UT RATE %</th>
                  <th>SGST/UT AMOUNT</th>
                </tr>
              </thead>
              <tbody>

                {invoiceData?.groupedItems?.length > 0 && invoiceData?.groupedItems.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td></td>
                      <td>{data?.hsnCode}</td>
                      <td>{data?.totalTaxableValue.toFixed(2)}</td>
                      <td>{data?.igstRate}</td>
                      <td>{data?.totalIGST.toFixed(2)}</td>
                      <td>{data?.cgstRate}</td>
                      <td>{data?.totalCGST.toFixed(2)}</td>
                      <td>{data?.sgstRate}</td>
                      <td>{data?.totalSGST.toFixed(2)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div> */}

          {/* <!-- Bottom Section --> */}
          <div className="bottom-section">
            <div className="payment-terms">
              {/* <div style={{ marginBottom: "10px" }}><strong>IRN NO. :</strong></div> */}

              <div className="total-words">
                {/* <div><strong>TOTAL GST PAYABLE (IN WORDS) : {totalGSTWords} */}
                  {/* {toWords.convert(invoiceData?.invoiceSummary?.totalamount)} */}
                  {/* {toWords.convert(invoiceData?.invoiceSummary?.totalamount);} */}
                {/* </strong></div> */}
                {/* <br /> */}
                <div><strong>TOTAL NET PAYABLE (IN WORDS) : {toWords.convert(Math.round(Number(invoiceData?.invoiceSummary?.totalAmount ?? 0))).toUpperCase()} RUPEES AND ZERO PAISE ONLY</strong></div>
              </div>
                <div>
                  <h6>Notes:<p>{invoiceData?.invoice?.subj_desc}</p></h6>
              </div>
            </div>

            <div className="amount-summary">
             <div className="amount-row" style={{ background: "#f0f0f0" }}>
                <div className="amount-label">NET PAYABLE AMOUNT</div>
                <div className="amount-value" style={{ fontWeight: "bold" }}>{invoiceData?.invoiceSummary?.totalAmount?? 0}</div>
             </div>
              {/* <div className="amount-row">
                <div className="amount-label">TAXABLE AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalTaxableAmount}</div>
              </div> */}
              {/* <div className="amount-row">
                <div className="amount-label">CGST AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalCGST.toFixed(2)}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">SGST/UT AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalSGST.toFixed(2)}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">IGST AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalIGST.toFixed(2)}</div>
              </div> */}
              {/* <div className="amount-row">
                <div className="amount-label">TOTAL AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalamount.toFixed(2)}</div>
              </div> */}
              {/* <div className="amount-row">
                <div className="amount-label">Rounding off</div>
                <div className="amount-value">{ invoiceData?.invoiceSummary?.roundOffValue }</div>
              </div> */}
             
            
            </div>
          </div>


          {/* terms conetent start */}
          
          </div>
    )
}
export default VendorInvoiceBody;